function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.754 22.552a.3.3 0 00.26.448h15.971a.3.3 0 00.261-.448L16.261 8.461a.3.3 0 00-.522 0L7.754 22.552zM17 21h-2v-2h2v2zm0-3h-2v-4h2v4z",
  fill: "#FC4F52"
});

var SvgIconError = function SvgIconError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03Ljc1Mzc5IDIyLjU1MjJDNy42NDA0NiAyMi43NTIyIDcuNzg0OTMgMjMuMDAwMSA4LjAxNDggMjMuMDAwMUgyMy45ODUyQzI0LjIxNSAyMy4wMDAxIDI0LjM1OTUgMjIuNzUyMiAyNC4yNDYyIDIyLjU1MjJMMTYuMjYxIDguNDYwNjlDMTYuMTQ2MSA4LjI1Nzg5IDE1Ljg1MzkgOC4yNTc5IDE1LjczOSA4LjQ2MDY5TDcuNzUzNzkgMjIuNTUyMlpNMTcgMjEuMDAwMUgxNVYxOS4wMDAxSDE3VjIxLjAwMDFaTTE3IDE4LjAwMDFIMTVWMTQuMDAwMUgxN1YxOC4wMDAxWiIgZmlsbD0iI0ZDNEY1MiIvPgo8L3N2Zz4K";
export { SvgIconError as ReactComponent };